import { render, staticRenderFns } from "./tabProductPromotions.vue?vue&type=template&id=1d320544&"
import script from "./tabProductPromotions.vue?vue&type=script&lang=js&"
export * from "./tabProductPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports